import { County } from 'src/app/model/county';
import { Region } from 'src/app/model/region.model';
import { Grade, School } from 'src/app/model/school.model';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { EnrollmentPeriods } from '../../common-components/child-services/model/enrollment-periods.model';
import { PartyServices } from '../../service-administration/model/party-services.model';
import { ServiceHourRanges } from '../../service-administration/model/service-hour-ranges.model';
import { CosReasons } from './cos-reasons.model';

export class ServiceDeliveries {
    [x: string]: any;
    ID: number;
    SCHOOL_YEAR: string;
    GRADES: string;
    SCHOOL_DISTRICT: string;
    SCHOOL_NAME: string;
    SERVICE_NAME: string;
    SERVICE_CODE: string;
    REGION_NAME: string;
    REGION_CODE: string;
    REGION_ID: number;
    START_DATE: Date;
    END_DATE: Date;
    STUDENTS_ID: number;
    PARTY_ROLES_ID: number;
    PARTY_SERVICES_ID: number;
    ENROLLMENT_PERIODS_ID: number;
    GRADES_ID: number;
    CREATED_BY: string;
    CREATED_DATE: Date;
    VERIFIED: string;
    PARTY_SERVICES: PartyServices;
    ENROLLMENT_PERIODS: EnrollmentPeriods;
    GRADE: Grade;
    SCHOOL: School;
    SCHOOL_DISTRICTS: SchoolDistrict;
    REGION: Region;
    COUNTY: County;
    SERVICE_HOUR_RANGES: ServiceHourRanges;
    PARTY_SERVICES_IDs: number[];
    SERVICE_HOUR_RANGES_ID: number;
    COS_REASONS: CosReasons;
    COS_REASONS_ID: number;
}
